import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsCardEventSchema = withDefaults({
  type: 'pcs-card-event',
  fields: [
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'providerEvent',
    },
    {
      kind: 'attribute',
      name: 'event',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'pcsCard',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'pcsCardEvents',
      },
    },
    {
      kind: 'attribute',
      name: 'sourceId',
    },
    {
      kind: 'attribute',
      name: 'sourceType',
    },
    {
      kind: 'attribute',
      name: 'sinkId',
    },
    {
      kind: 'attribute',
      name: 'sinkType',
    },
  ],
});

export default PcsCardEventSchema;
